export const DEFAULT_ORDER = "DEFAULT_ORDER";
export const CUSTOMIZED_ORDER = "CUSTOMIZED_ORDER";
export const ORDER_BY_POSITIVE_ATTRIBUTES = "ORDER_BY_POSITIVE_ATTRIBUTES";
export const ORDER_BY_CATEGORY = "ORDER_BY_CATEGORY";
export const ORDER_BY_NAME = "ORDER_BY_NAME";
export const ORDER_BY_ASSESSMENT_TIER ="ORDER_BY_ASSESSMENT_TIER";

export const getSortOrderText = (order, section = "") => {
  let title, description = "";
  switch (order) {
    case DEFAULT_ORDER:
      title = "Default Order";
      if(section === "assessment"){
          description = "Options are first sorted with those passing all criteria at the top and those eliminated below. Then for options passing criteria, those in the mid and high assessment 'tiers' " +
          "are sorted above the extremely data-poor and pre-assessment options. Finally within each of these groups, options having the strongest caveats are sorted above those having less caveats.";
      } else {
        description = "Options are first sorted with those passing all criteria at the top and those eliminated below. Then those having the strongest caveats are sorted above those having less caveats.";
      }
      break;
    case ORDER_BY_NAME:
      title = "Alphabetically by Option Name";
      description = "Options are sorted alphabetically by the option name.";
      break;
    case ORDER_BY_CATEGORY:
      title = "By Option Category";
      description = "Options are sorted based on the category they belong to.";
      break;
    case CUSTOMIZED_ORDER:
      title = "Custom Sort Order";
      description = "The sort order is defined by the user. Click and hold on an option row to drag and drop options into the order preferred."
      break;
    case ORDER_BY_ASSESSMENT_TIER:
      title = "By Assessment 'Tier'";
      description = "Options are sorted based on the assessment 'tier' of the option. Options in the highest 'tier' are at the top and pre-assessments at the bottom."
      break;
    default:
      title = "Options"
      description = "Caveats and criteria for each option are determined based on the results of the questionnaire."
  }
  return{
    title: title,
    description: description
  }
}

const orderOptions = [
  DEFAULT_ORDER,
  CUSTOMIZED_ORDER,
  ORDER_BY_POSITIVE_ATTRIBUTES,
  ORDER_BY_CATEGORY,
  ORDER_BY_NAME,
  ORDER_BY_ASSESSMENT_TIER
];

export const UPDATE_CATEGORY_PROP = 'UPDATE_CATEGORY_PROP';
export const updateCategoryProp = (value, section) => ({
  type: UPDATE_CATEGORY_PROP,
  value,
  section
})

export const UPDATE_RESULTS_ORDER = "UPDATE_RESULTS_ORDER";
export const updateResultsOrder = (section, order) => {
  if (orderOptions.indexOf(order) === -1) {
    throw new Error(
      `Invalid order. Should be one of ${orderOptions.join(", ")}`
    );
  }
  return {
    type: UPDATE_RESULTS_ORDER,
    section,
    order
  };
};

export const TOGGLE_HIDDEN_OPTIONS = 'TOGGLE_HIDDEN_OPTIONS';
export const toggleHiddenOptions = (section) => ({
  type: TOGGLE_HIDDEN_OPTIONS,
  section
});

export const TOGGLE_LIMIT_TO_TAGS = 'TOGGLE_LIMIT_TO_TAGS';
export const toggleLimitToTags = (section) => ({
  type: TOGGLE_LIMIT_TO_TAGS,
  section
});

export const UPDATE_LIMITED_TAGS = 'UPDATE_LIMITED_TAGS';
export const updateLimitedTags = (tags, section) => ({
  type: UPDATE_LIMITED_TAGS,
  section,
  tags
});

export const TOGGLE_HIDE_TAGS = 'TOGGLE_HIDE_TAGS';
export const toggleHideTags = (section) => ({
  type: TOGGLE_HIDE_TAGS,
  section
});

export const UPDATE_HIDDEN_TAGS = 'UPDATE_HIDDEN_TAGS';
export const updateHiddenTags = (tags, section) => ({
  type: UPDATE_HIDDEN_TAGS,
  section,
  tags
});

export const TOGGLE_SHORT_LIST = "TOGGLE_SHORT_LIST";
export const toggleShortList = (section) => ({
  type: TOGGLE_SHORT_LIST,
  section
});

export const UPDATE_FILTER_OPTIONS = "UPDATE_FILTER_OPTIONS";
export const updateFilterOptions = (options, section) => ({
  type: UPDATE_FILTER_OPTIONS,
  options,
  section
})
